import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

// eslint-disable-next-line import/no-named-as-default-member
dayjs.extend(utc)
// eslint-disable-next-line import/no-named-as-default-member
dayjs.extend(timezone)

const hash = (id = '') => 10 + (id.split('').reduce((acc, c) => acc + c.charCodeAt(0), 0) % 10)

const coefficientPerHours = {
  '0': 0.4333333333,
  '1': 0.1666666667,
  '2': 0.06666666667,
  '3': 0.03333333333,
  '4': 0.1,
  '5': 0.2,
  '6': 0.4,
  '7': 0.8333333333,
  '8': 0.7666666667,
  '9': 0.6,
  '10': 0.6666666667,
  '11': 0.6666666667,
  '12': 0.8666666667,
  '13': 1.066666667,
  '14': 1.033333333,
  '15': 0.8,
  '16': 0.7666666667,
  '17': 0.7333333333,
  '18': 0.8666666667,
  '19': 0.8333333333,
  '20': 1.033333333,
  '21': 0.9,
  '22': 1.133333333,
  '23': 0.4,
}

export const getPreviousHourViews = (id: string): number => {
  const value = hash(id)
  const tolerance = 12
  const previousHour = dayjs.tz(new Date(), 'Europe/Rome').subtract(1, 'hour').hour()
  const dayOfMonth = dayjs.tz(new Date(), 'Europe/Rome').date()
  const coefficient = coefficientPerHours[previousHour]

  const activeUser = value + ((previousHour + dayOfMonth) % tolerance)
  const returnValue = Math.ceil(activeUser * coefficient)
  return returnValue < 1 ? 1 : returnValue
}
